module.exports = __webpack_public_path__ + "static/media/netwell-logo1.62fcf0ab.png";